// Extract a clean @username (or plain username for Facebook) from either a bare
// handle or a full profile URL pasted into a social contact field.
// Supported: instagram, tiktok, youtube, x (twitter), facebook.

export const SOCIAL_TYPES = ["instagram", "tiktok", "youtube", "x", "facebook"];

function withAt(u) {
    const s = (u || "").replace(/^@+/, "").trim();
    return s ? "@" + s : "";
}

export function extractSocialHandle(type, raw) {
    let v = (raw || "").trim();
    if (!v || !SOCIAL_TYPES.includes(type)) return v;

    const hasDomain = /(instagram\.com|instagr\.am|tiktok\.com|youtube\.com|youtu\.be|twitter\.com|x\.com|facebook\.com|fb\.com|fb\.me)/i.test(v);
    const isUrl = /^https?:\/\//i.test(v) || hasDomain;

    if (!isUrl) {
        // Bare handle typed by the user.
        return type === "facebook" ? v.replace(/^@+/, "") : withAt(v);
    }

    // Parse the path out of the URL.
    let s = v.replace(/^https?:\/\//i, "").replace(/^www\./i, "");
    s = s.split("?")[0].split("#")[0];
    const parts = s.split("/").filter(Boolean); // [domain, seg1, seg2, ...]
    const path = parts.slice(1);
    const seg0 = path[0] || "";

    switch (type) {
        case "instagram":
        case "x":
            return withAt(seg0) || v;
        case "tiktok":
            return withAt(seg0.replace(/^@/, "")) || v;
        case "youtube": {
            if (seg0.startsWith("@")) return seg0;
            const low = seg0.toLowerCase();
            if (low === "channel") return path[1] || v;          // channel IDs have no @
            if (low === "c" || low === "user") return withAt(path[1]) || v;
            return withAt(seg0) || v;
        }
        case "facebook": {
            if (seg0.toLowerCase() === "profile.php") return v;  // numeric id lives in the query string
            return seg0 || v;
        }
        default:
            return v;
    }
}

// Value to show on detail pages — always the clean handle for social types.
export function displaySocialValue(type, value) {
    if (SOCIAL_TYPES.includes(type)) return extractSocialHandle(type, value) || value;
    return value;
}
